import { render, staticRenderFns } from "./EsqueceuSenha.vue?vue&type=template&id=5a5d0839&scoped=true"
import script from "./EsqueceuSenha.vue?vue&type=script&lang=js"
export * from "./EsqueceuSenha.vue?vue&type=script&lang=js"
import style0 from "./EsqueceuSenha.vue?vue&type=style&index=0&id=5a5d0839&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5d0839",
  null
  
)

export default component.exports